
import './Team.css'
import ucdavis from "./Profile/logo/Logo_CADMS.png"
import uncr from './Profile/logo/Logo_UCANR.png'
import wsu from './Profile/logo/Logo_WSU.png'
import wsda from './Profile/logo/Logo_WSDA.jpg'
import csu from './Profile/logo/Logo_CSU.png'


import {mcconnel,pereira, itle, adams, pires, lopez, busch, francesco, bushwell} from "./Profile/description";



import Profile from "./Profile/Profile"

const Team = () => {
    return (
        <div className = 'section'>
            <h1>Meet the Team</h1>
            <div id = 'team-info'>
                <Profile details = {pires}   school_logo = {uncr}> </Profile>
                <Profile details={francesco}> </Profile>
                <Profile details={lopez} school_logo = {ucdavis} > </Profile>
                <Profile details={mcconnel} school_logo = {wsu} > </Profile>
                <Profile details={pereira}> </Profile>
                <Profile details={itle} school_logo = {wsda}> </Profile>
                <Profile details={adams} school_logo= {csu}> </Profile>
                <Profile details={busch}> </Profile>
                <Profile details={bushwell} school_logo={wsda}> </Profile>
            </div>
        </div>
    )
}

export default Team;